export default "__VITE_PUBLIC_ASSET__16715afd__"